export function addItemToInventory(item) {
  return {
    type: 'ADD_ITEM_TO_INVENTORY',
    payload: item,
  };
}

export function removeItemFromInventory(item) {
  return {
    type: 'REMOVE_ITEM_FROM_INVENTORY',
    payload: item,
  };
}
